export { default } from './AssignFeature.js';